import { LayerTypeLayerSummaryProps, SupportedRegions } from "../../types";
import { useWorkbench } from "../../Bundle/Workbench/WorkbenchContext";
import {
  UKPropertyInformationSelectionContent,
  usePropertiesBySelection,
} from "./UKPropertyInformationSelectionSidebar/UKPropertyInformationSelectionSidebar";
import { SkeletonLoading } from "react-migration/components/SkeletonLoading";
import { useSelectionSidebarLoading } from "../../Bundle/useSelectionSidebarLoadingState";

export const UKPropertyInformationSummary = ({ selection, onLoadingChange }: LayerTypeLayerSummaryProps) => {
  const { setDetailSelection } = useWorkbench();

  const { properties, loading } = usePropertiesBySelection(selection);

  useSelectionSidebarLoading(onLoadingChange, loading);

  if (loading) {
    return (
      <div className="flex flex-col gap-3">
        <div className="relative p-2 h-[96px]">
          <SkeletonLoading rows={2} cols={2} showPadding={false} bgClassName="bg-transparent" />
        </div>

        <div className="relative h-[36px]">
          <SkeletonLoading rows={1} showPadding={false} bgClassName="bg-transparent" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col divide-y divide-solid divide-neutral-200">
      <UKPropertyInformationSelectionContent properties={properties} setDetailSelection={setDetailSelection} />
    </div>
  );
};

UKPropertyInformationSummary.icon = "icon-lt-home-line";
UKPropertyInformationSummary.title = "Properties on site";
UKPropertyInformationSummary.hideLink = true;
UKPropertyInformationSummary.supportedRegions = [
  SupportedRegions.england,
  SupportedRegions.scotland,
  SupportedRegions.wales,
];
